import { render, staticRenderFns } from "./PoiCard.vue?vue&type=template&id=4ec0df04&scoped=true&"
import script from "./PoiCard.vue?vue&type=script&lang=js&"
export * from "./PoiCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0df04",
  null
  
)

export default component.exports